import { Action } from '@ngrx/store';

export const LOGOUT_COMPLETE = '[Security] Logout Complete';

export class LogoutCompleteAction implements Action {
  readonly type = LOGOUT_COMPLETE;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/LogoutCompleteAction.ts